import { FundingRoundsData } from '../types/funding';
import FundingRoundsTable from './FundingRoundsTable';

interface FundingRoundsCardProps {
  data: FundingRoundsData;
}

export default function FundingRoundsCard({ data }: FundingRoundsCardProps) {
  return (
    <div className="funding-rounds mt-6 px-4 sm:px-12 md:px-12">
      <div className="border border-gray-200 rounded-lg">
        <div className="border-b border-gray-200 p-4">
          <h2 className="text-lg font-semibold">Funding Rounds</h2>
        </div>
        <div className="p-4">
          <FundingRoundsTable data={data} />
        </div>
      </div>
    </div>
  );
}
